// import { MapPinIcon } from "@heroicons/react/24/outline";
// import { StatusBadge } from "../../../../shared/components/ui";
// import TabbedForm from "../../../../shared/components/forms/FormTabs";
// import DistricExpandedRow from "../components/DistricExpandRow";
// import { DistrictService } from "../../../../shared/services/districtService";

// /* ------------------- Helpers ------------------- */
// const loadOptions = async (loaderFn, fallbackData = []) => {
//   try {
//     return await loaderFn();
//   } catch (error) {
//     console.warn("API failed, using fallback data.", error);
//     return fallbackData;
//   }
// };

// // export const getDistrictOptions = async () => {
// //   try {
// //     const res = await DistrictService.getDistrictDropdown();
// //     return res?.data?.map(d => ({ value: d.value, label: d.label, code: d.code })) || [];
// //   } catch (error) {
// //     console.warn("Failed to load districts", error);
// //     return [];
// //   }
// // };

// const generateDistrictCode = (state, district) => {
//   if (!state || !district) return "";
//   const stateCode = state.slice(0, 2).toUpperCase();
//   const districtCode = district.slice(0, 3).toUpperCase();
//   return `${stateCode}-${districtCode}`;
// };

// /* ------------------- Config ------------------- */
// export const districtConfig = {
//   title: "district",
//   endpoint: "districts",
//   icon: MapPinIcon,
//   useUrlNavigation: true,
//   basePath: '/admin/distric',
//   searchFields: ["name", "districtCode"],

//   /* ---------- Table Columns ---------- */
//   columns: [
//     { key: "name", label: "District Name", render: (item) => item.name },
//     {
//       key: "districtCode",
//       label: "Code",
//       render: (item) => (
//         <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs font-medium">
//           {item.districtCode}
//         </span>
//       ),
//     },
//     { key: "state", label: "State", render: (item) => item.state },
//     {
//       key: "status",
//       label: "Status",
//       render: (item) => <StatusBadge status={item.status} />,
//     },
//   ],

//   /* ---------- Form Fields ---------- */
//   formFields: [
//     // {
//     //   name: "state",
//     //   label: "State",
//     //   type: "text",
//     //   required: true,
//     //   section: "basic",
//     //   placeholder: "Enter State",
//     // },
   
//   {
//       name: "name",
//       label: "distric",
//       type: "text",
//       required: true,
//       section: "basic",
//     },
//   {
//       name: "state",
//       label: "state",
//       type: "text",
//       required: true,
//       section: "basic",
//     },
//     {
//       name: "districtCode",
//       label: "Code",
//       type: "text",
//       readOnly: true, 
//       section: "basic",
//     },
//     {
//       name: "description",
//       label: "Description",
//       type: "textarea",
//       fullWidth: true,
//       section: "basic",
//     },

//     {
//       name: "contactPerson",
//       label: "Contact Person",
//       type: "text",
//       required: true,
//       section: "contact",
//     },
//     {
//       name: "phone",
//       label: "Phone Number",
//       type: "tel",
//       required: true,
//       section: "contact",
//     },
//     {
//       name: "email",
//       label: "Email",
//       type: "email",
//       required: true,
//       section: "contact",
//     },
//     {
//       name: "officeAddress",
//       label: "Office Address",
//       type: "textarea",
//       rows: 3,
//       fullWidth: true,
//       required: true,
//       section: "contact",
//     },
//   ],

//   formState: { activeTab: "basic" },

//   /* ---------- Custom Logic ---------- */
//   customHandlers: {
//     // 🔥 THIS IS THE KEY FIX
//     onFieldChange: (name, value, formData, option) => {
//   if (name === "districtId") {
//     return {
//       districtId: value,           // ID
//       name: option?.label || "",   // District name
//       districtCode: generateDistrictCode(formData.state, option?.label),
//     };
//   }

//   if (name === "state") {
//     return {
//       state: value,
//       districtCode: generateDistrictCode(value, formData.name),
//     };
//   }

//   return null;
// },

//     // onFieldChange: (name, value, formData) => {
//     //   // State changed → regenerate code
//     //   if (name === "state") {
//     //     return {
//     //       state: value,
//     //       districtCode: generateDistrictCode(value, formData.name),
//     //     };
//     //   }

//     //   // District changed → regenerate code
//     //   if (name === "name") {
//     //     return {
//     //       name: value,
//     //       districtCode: generateDistrictCode(formData.state, value),
//     //     };
//     //   }

//     //   return null;
//     // },

//     // renderFormSections: (
//     //   formFields,
//     //   formData,
//     //   handleFormChange,
//     //   mode,
//     //   renderFormField
//     // ) => {
//     //   const tabsConfig = {
//     //     basic: { label: "Basic Info" },
//     //     contact: { label: "Contact Info" },
//     //   };

//     //   return (
//     //     <TabbedForm
//     //       formFields={formFields}
//     //       formData={formData}
//     //       handleFormChange={handleFormChange}
//     //       renderFormField={renderFormField}
//     //       tabsConfig={tabsConfig}
//     //     />
//     //   );
//     // },

    


//     renderFormSections: (formFields, formData, handleFormChange, mode, renderFormField, activeTab, setActiveTab) => {
//       const tabsConfig = {
//         basic: { label: "Basic Info" },
//         contact: { label: "Contact Info" },
//       };
//       return <TabbedForm formFields={formFields} formData={formData} handleFormChange={handleFormChange} renderFormField={renderFormField} tabsConfig={tabsConfig} activeTab={activeTab} setActiveTab={setActiveTab} />;
//     },

//     renderExpandedRow: (item) => <DistricExpandedRow item={item} />,

//     processFormData: (formData) => ({
//       ...formData,
//       districtCode: formData.districtCode?.toUpperCase(),
//     }),
//   },
// };

// export default districtConfig;
import { MapPinIcon } from "@heroicons/react/24/outline";
import { StatusBadge } from "../../../../shared/components/ui";
import TabbedForm from "../../../../shared/components/forms/FormTabs";
import DistricExpandedRow from "../components/DistricExpandRow";

/* ------------------- Helpers ------------------- */
const generateDistrictCode = (state, district) => {
  if (!state || !district) return "";
  const stateCode = state.slice(0, 2).toUpperCase();
  const districtCode = district.slice(0, 3).toUpperCase();
  return `${stateCode}-${districtCode}`;
};

/* ------------------- Config ------------------- */
export const districtConfig = {
  title: "district",
  endpoint: "admin/districts",
  crudEndpoint: "districts",
  icon: MapPinIcon,
  useUrlNavigation: true,
  basePath: "/admin/distric",
  searchFields: ["name", "districtCode"],

  /* ---------- Table Columns ---------- */
  columns: [
    {
      key: "name",
      label: "District Name",
      render: (item) => item.name,
    },
    {
      key: "districtCode",
      label: "District Code",
      render: (item) => (
        <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs font-medium">
          {item.districtCode || "—"}
        </span>
      ),
    },
    {
      key: "state",
      label: "State",
      render: (item) => item.state,
    },
    {
      key: "status",
      label: "Status",
      render: (item) => <StatusBadge status={item.status} />,
    },
  ],

  /* ---------- Form Fields ---------- */
  formFields: [
    {
      name: "name",
      label: "District Name",
      type: "text",
      required: true,
      section: "basic",
      placeholder: "Enter district name",
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: true,
      section: "basic",
      placeholder: "Enter state name",
    },
    {
      name: "districtCode",
      label: "District Code",
      required: true,
      type: "text",
      section: "basic",
      placeholder: "Enter district code Ex: GJ-01",
    },
    // {
    //   name: "description",
    //   label: "Description",
    //   type: "textarea",
    //   rows: 3,
    //   fullWidth: true,
    //   section: "basic",
    // },

    /* -------- Contact Section -------- */
    {
      name: "contactPerson",
      label: "Contact Person",
      type: "text",
      required: true,
      section: "contact",
      placeholder: "Enter contact person name",
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "tel",
      required: true,
      section: "contact",
      placeholder: "9876543210",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
      section: "contact",
      placeholder: "district@example.com",
    },
    {
      name: "officeAddress",
      label: "Office Address",
      type: "textarea",
      rows: 3,
      fullWidth: true,
      required: true,
      section: "contact",
      placeholder: "District Office, Main Road",
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "ACTIVE", label: "Active" },
        { value: "INACTIVE", label: "Inactive" },
      ],
      required: true,
      section: "contact",
    },
  ],

  formState: {
    activeTab: "basic",
  },

  /* ---------- Custom Logic ---------- */
  customHandlers: {

    renderFormSections: (
      formFields,
      formData,
      handleFormChange,
      mode,
      renderFormField,
      activeTab,
      setActiveTab
    ) => {
      const tabsConfig = {
        basic: { label: "Basic Info" },
        contact: { label: "Contact Info" },
      };

      return (
        <TabbedForm
          formFields={formFields}
          formData={formData}
          handleFormChange={handleFormChange}
          renderFormField={renderFormField}
          tabsConfig={tabsConfig}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      );
    },

    renderExpandedRow: (item) => <DistricExpandedRow item={item} />,

    processFormData: (formData) => ({
      ...formData,
      districtCode: formData.districtCode?.toUpperCase(),
    }),
  },
};

export default districtConfig;
